<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8423_3041)">
<circle cx="8.5" cy="8.5" r="8" fill="currentColor"/>
<path d="M8.99983 4.72876C8.99983 4.45262 8.77597 4.22876 8.49983 4.22876C8.22369 4.22876 7.99983 4.45262 7.99983 4.72876L7.99983 8L4.72859 8C4.45245 8 4.22859 8.22386 4.22859 8.5C4.22859 8.77614 4.45245 9 4.72859 9L7.99983 9L7.99983 12.2712C7.99983 12.5474 8.22369 12.7712 8.49983 12.7712C8.77597 12.7712 8.99983 12.5474 8.99983 12.2712L8.99983 9L12.2711 9C12.5472 9 12.7711 8.77614 12.7711 8.5C12.7711 8.22386 12.5472 8 12.2711 8L8.99983 8L8.99983 4.72876Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_8423_3041">
<rect width="16" height="16" fill="white" transform="translate(0.5 0.5)"/>
</clipPath>
</defs>
</svg>
